import { LastBidderToolbarController } from "./last-bidder-toolbar.controller";
import "./link-payment-states/link-payment-states.component";
import "./payment-actions/payment-actions.component";

angular
    .module("thor.online-containers.edit.last-bidder-toolbar.component", [
        "thor.online-containers.edit.link-payment-states.component",
        "thor.online-containers.edit.payment-actions.component"
    ])
    .component("lastBidderToolbar", {
        bindings: {
            user: "<",
            containerEndDate: "<",
            containerId: "<",
            contractId: "<",
            getItems: "&",
            payments: "<",
            paymentStatus: "<",
            saleCurrency: "<",
            saleDepositAmount: "<",
            salePaymentDeposit: "<"
        },
        controller: LastBidderToolbarController,
        controllerAs: "lastBidderCtrl",
        template: require("./last-bidder-toolbar.html")
    });
